<div style="background-image: url('../../../assets/img/landing-page-brands/shop-from-us-to-australia-1.webp'); background-size: cover; background-repeat: no-repeat;"
    class="static-landing-page-bg-wrapper">
    <div class="shippn-homepage-container container">
        <div class="row">
            <div style="text-align: center;" class="col-md-12">
                <div class="static-landing-page-heading-wrapper">
                    <h1
                        class="static-landing-page-heading">
                        Shop from U.S. online stores and ship to the Germany with Shippn
                    </h1>
                    <h4 class="static-landing-page-subheading">
                        Buy from over a million U.S. stores with ease and enjoy seamless, hassle-free international shipping to the Germany with Shippn
                    </h4>
                  </div>
            </div>
        </div>
    </div>
</div>


<div>
    <div class="shippn-homepage-container container">
        <div class="row padFix-padB-50 padFix-padT-50">
            <div style="text-align: left;" class="col-md-12 landing-page-wrapper">
                <p style="font-size: 15px;font-weight: 400;margin-top: 20px;margin-bottom: 20px;">
                    Looking for the most fashionable clothes, accessories, and shoe brands in the US? We've compiled a list of the top online stores where you can find the latest trends with just a few clicks.
                  </p>
                  <p style="font-size: 15px;font-weight: 400;margin-top: 20px;margin-bottom: 20px;">
                    With Shippn, buying from the US and shipping to the Germany has never been easier! Simply sign up to get your <strong>free US shipping address</strong>, shop at your favorite American stores, and let us deliver your order to your doorstep in <strong>1-5 business days</strong>.
                  </p>
                  <p style="font-size: 15px;font-weight: 400;margin-top: 20px;margin-bottom: 20px;">
                    No matter where you live, <strong>Shippn </strong> <strong>ensures fast</strong>, <strong>reliable</strong>, and <strong>hassle-free </strong> <strong>international shipping from the US to the Germany </strong> <a style="color:#000; text-decoration:underline; font-weight: 800;" href="https://www.shippn.com/signup">Start shopping today!</a>
                  </p>

                <a href="https://www.shippn.com/shop-from/us" class="btn mb-4 shippn-from-to-area-go-btn">START SHOPPING</a>

                <div>Now, start to discover US brands:</div>

                <strong>Top US Fashion Brands</strong>
                <ul class="landing-page-brands">
                    <li>
                        <a href="https://www.abercrombie.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/abercrombie-fitch.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Abercrombie & Fitch Logo">
                            <hr>
                            <h3 class="text-center">Abercrombie &amp; Fitch</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.aeropostale.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/aeropostale-logo.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Aeropostale Logo">
                            <hr>
                            <h3 class="text-center">Aeropostale</h3>
                            <hr>
                        </a>
                    </li>

                    <li>
                        <a href="https://www.adidas.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/adidas.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Adidas logo">
                            <hr>
                            <h3 class="text-center">Adidas</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.ae.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/american-eagle.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="American Eagle logo">
                            <hr>
                            <h3 class="text-center">American Eagle</h3>
                            <hr>
                        </a>
                    </li>

                    <li>

                        <a href="https://www.armaniexchange.com/us" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/armani_exchange.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Armani exchange logo">
                            <hr>
                            <h3 class="text-center">Armani Exchange</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.bloomingdales.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/Bloomingdale.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Bloomingdale's logo">
                            <hr>
                            <h3 class="text-center">Bloomingdale's</h3>
                            <hr>
                        </a>
                    </li>
                    <li>

                        <a href="https://www.bluefly.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/bluefly.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Bluefly logo">
                            <hr>
                            <h3 class="text-center">Bluefly</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.eastbay.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/Eastbay.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Eastbay logo">
                            <hr>
                            <h3 class="text-center">Eastbay</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.forever21.com/us/shop" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/forever21.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Forever 21 logo">
                            <hr>
                            <h3 class="text-center">Forever 21</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.gucci.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/gucci.webp" class="img-responsive"
                                ng-show="brand.brand_logo" alt="Gucci Logo">
                            <hr>
                            <h3 class="text-center">Gucci</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.guess.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/guess.webp" class="img-responsive"
                                ng-show="brand.brand_logo" alt="Guess Logo">
                            <hr>
                            <h3 class="text-center">Guess</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.harley-davidson.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/harley-davidson.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Harley Davidson logo">
                            <hr>
                            <h3 class="text-center">Harley-Davidson</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.macys.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/macys.webp" class="img-responsive"
                                ng-show="brand.brand_logo" alt="Macy's logo">
                            <hr>
                            <h3 class="text-center">Macy's</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.michaelkors.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/michael-kors.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Michael Kors logo">
                            <hr>
                            <h3 class="text-center">Michael Kors</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.neimanmarcus.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/neiman-marcus.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Neiman Marcus logo">
                            <hr>
                            <h3 class="text-center">Neiman Marcus</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.net-a-porter.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/net-a-porter.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Net-a-porter logo">
                            <hr>
                            <h3 class="text-center">Net-a-Porter</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.nike.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/nike.webp" class="img-responsive"
                                ng-show="brand.brand_logo" alt="Nike logo">
                            <hr>
                            <h3 class="text-center">Nike</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.ninewest.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/nine-west.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Nine west logo">
                            <hr>
                            <h3 class="text-center">Nine West</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.ralphlauren.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/ralp_lauren.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Ralph Lauren">
                            <hr>
                            <h3 class="text-center">Ralph Lauren</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.saksfifthavenue.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/saks-fifth-avenue.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Saks Fifth avenue logo">
                            <hr>
                            <h3 class="text-center">Saks Fifth Avenue</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.swarovski.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/swarovski-1.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="swarovski logo">
                            <hr>
                            <h3 class="text-center">Swarovski</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.uniqlo.com" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/uniqlo-1.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="uniqlo logo">
                            <hr>
                            <h3 class="text-center">Uniqlo</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.urbanoutfitters.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/Urban-Outfitters.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="urban outfitters logo">
                            <hr>
                            <h3 class="text-center">Urban Outfitters</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.vans.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/vans.webp" class="img-responsive"
                                ng-show="brand.brand_logo" alt="vans logo">
                            <hr>
                            <h3 class="text-center">Vans</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.victoriassecret.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/victoriassecret.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="victoria's secret logo">
                            <hr>
                            <h3 class="text-center">Victoria's Secret</h3>
                            <hr>
                        </a>
                    </li>
                    <li>
                        <a href="https://www.zappos.com/" target="_blank" rel="external nofollow">
                            <img src="../../../assets/img/landing-page-brands/zappos.webp"
                                class="img-responsive" ng-show="brand.brand_logo" alt="Zappos logo">
                            <hr>
                            <h3 class="text-center">Zappos</h3>
                            <hr>
                        </a>
                    </li>
                </ul>

                <strong>Top US E-commerce Sites</strong>
                <ul>
                    <li>Amazon.com</li>
                    <li>Bestbuy.com</li>
                    <li>Ebay.com</li>
                    <li>Walmart.com</li>
                    <li>Wayfair.com</li>
                </ul>

                <div>Learn more about the Shippn <a href="/shipping-cost-calculator" target="_blank">prices</a> before you order, and you
                    can choose DHL, FedEx, or TNT to have your items shipped.</div>

                <div class="landing-page-btn">
                    <a href="https://www.shippn.com/shop-from/us" class="btn shippn-from-to-area-go-btn">START SHOPPING</a>
                </div>

                <div>Need to shop from US and ship to Germany? Use Shippn to get a local address in the US and ship
                    your purchases to Germany</div>

                <div>Shipping to the US is easy with Shippn. Our hosts ship your products with express carriers like
                    DHL, FedEx, or UPS.</div>

                <div>
                    <h5 class="text-dark">Shipping Rates to the US</h5>
                </div>

                <div>Shippn provides safe and affordable shipping from the US to Germany. Whether you are a business
                    or sending a personal package, you can easily save up to 70% on your international shipping costs by
                    way of accessing our group buying power.</div>

                <div>Click <a href="/shipping-cost-calculator" target="_blank">here</a> and estimate your shipping costs.</div>

                <div>
                    <h5 class="text-dark">Type of Shipment US to Germany</h5>
                </div>

                <div>Not all types of shipments are created equal. Shipping a television will require different
                    paperwork, duties, and taxes than shipping an accounting statement, for example.</div>

                <div>Here is a list of the most common types of shipments:</div>

                <ul>
                    <li>Documents Only</li>
                    <li>Gifts</li>
                    <li>Personal Effects / Personal belongings</li>
                    <li>Food, Chocolate, Candies</li>
                    <li>Samples</li>
                    <li>Advertising material</li>
                    <li>Repaired Equipment</li>
                    <li>Temporary imports (i.e. trade shows, exhibits, etc)</li>
                    <li>Permanent or Sold Goods</li>
                </ul>

                <div>
                    <h5 class="text-dark">Prohibited &amp; Restricted Imports US to Germany</h5>
                </div>

                <div>Certain goods are prohibited from entering Germany and others have restrictions. Prohibitions and
                    restrictions are in place to protect children, minors, and German citizens, protect the German
                    constitution and abide by international trade agreements.</div>

                <div>Here’s an abbreviated list of items that are prohibited or restricted from shipping to Germany. An
                    extensive list can be found <a
                        href="https://www.zoll.de/DE/Fachthemen/Verbote-Beschraenkungen/Schutz-der-menschlichen-Gesundheit/Produktsicherheit/produktsicherheit.html"
                        target="_blank" rel="external nofollow">here</a>.</div>

                <div><strong>Prohibited Products US to Germany</strong></div>

                <ul>
                    <li>Potatoes</li>
                    <li>Caviar from sturgeon</li>
                    <li>Vitamin and dietary supplements are considered to be medicinal supplements to treat diseases and
                        illnesses</li>
                    <li>Animal products, including milk and cheeses</li>
                    <li>Pornographic and obscene material</li>
                    <li>Material with violent and anti-democratic messages</li>
                    <li>Material that depicts violence or disparages symbols of the German state or government</li>
                    <li>Counterfeit items</li>
                    <li>Electric shock devices<br></li>
                </ul>

                <div><strong>Restricted Products US to Germany</strong></div>

                <ul>
                    <li>Medicines and narcotics</li>
                    <li>Rough diamonds (a valid Kimberly Certificate required)</li>
                    <li>Skins and products from dogs, cats, and seals</li>
                    <li>Cannabis (valid permit required from Health Canada)</li>
                    <li>Fireworks</li>
                    <li>Works of Cultural Heritage</li>
                    <li>Weapons and ammunition</li>
                </ul>

                <div class="text-dark">
                    <h5>Questions about Shipping from the US to Germany</h5>
                </div>

                <div><strong>How long does it take to ship to Germany from the US?</strong></div>

                <div>Shipping to Germany from the US can take between 2-5 business days through the fastest carriers
                    available on the Shippn platform.</div>

                <div>Find out <a href="/shipping-cost-calculator" target="_blank">how fast the Shippn trusted carriers can get your
                        shipment delivered to Germany</a> by getting a quote now.</div>

                <div>For other questions, you can <a href="/help">contact</a> Shippn teams.</div>
            </div>
        </div>
    </div>
</div>